import React from "react"
import { Typeahead } from "react-bootstrap-typeahead"
import { 
  Well 
} from "react-bootstrap"

export default function TrainingsFilterSidebar(props) {
  // PROPS
  const { 
    trainingsFilters,
    handleFilterChange,
    types,
    numbers,
    versions
  } = props

  // RENDER
  return (
    <div id="QMS-Filters-Sidebar">
      <Well>
        <center>
          <h3>Filter By</h3>
        </center>
  
        <div>
          <h5>Type(s)</h5>
          <Typeahead
            id="TypeFilterTypeahead"
            clearButton
            labelKey="type"
            multiple
            selected={trainingsFilters.selected_types} // Updated to snake_case
            options={types}
            placeholder="Select Type(s)"
            onChange={(selectedTypes) => {
              handleFilterChange('selected_types', selectedTypes); // Updated to snake_case
            }}
          />
        </div>
        <div>
          <h5>Number(s)</h5>
          <Typeahead
            id="NumberFilterTypeahead"
            clearButton
            labelKey="number"
            multiple
            selected={trainingsFilters.selected_numbers} // Updated to snake_case
            options={(numbers || []).sort((a, b) => {
              const nameA = a.number || a;
              const nameB = b.number || b;
              return nameA.localeCompare(nameB);
            })}
            placeholder="Select Number(s)"
            onChange={(selectedNumbers) => {
              handleFilterChange('selected_numbers', selectedNumbers); // Updated to snake_case
            }}
          />
        </div>
        <div>
          <h5>Version(s)</h5>
          <Typeahead
            id="VersionFilterTypeahead"
            clearButton
            labelKey="version"
            multiple
            selected={trainingsFilters.selected_versions} // Updated to snake_case
            options={(versions || [])
              .map(version => String(version)) // Ensure all versions are strings
              .sort((a, b) => parseInt(a, 10) - parseInt(b, 10))} // Sort numerically
            placeholder="Select Version(s)"
            onChange={(selectedVersions) => {
              handleFilterChange('selected_versions', selectedVersions); // Updated to snake_case
            }}
          />
        </div>
        <div>
          <h5>Published Status</h5>
          <Typeahead
            id="PublishedStatusFilterTypeahead"
            clearButton
            multiple
            selected={trainingsFilters.selected_published_statuses} // Updated to snake_case
            options={["Published", "Not Published"]}
            placeholder="Select Published Status"
            onChange={(selectedPublishedStatuses) => {
              handleFilterChange('selected_published_statuses', selectedPublishedStatuses); // Updated to snake_case
            }}
          />
        </div>
      </Well>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/TrainingContainer/TrainingsFilterSidebar.js